import React from "react";

const Button = ({ className, children, icon, type, onClick, disabled }) => {
  return (
    <button
      disabled={disabled && disabled}
      onClick={onClick}
      type={type ? type : "button"}
      className={`${className} w-60 h-12 max-sm:w-44 max-sm:h-10 rounded-xl flex items-center justify-center gap-2.5 text-base max-sm:text-sm font-medium`}
    >
      {icon && icon}
      <p>{children}</p>
    </button>
  );
};

export default Button;
